// extracted by mini-css-extract-plugin
export default {"GamesList":"GamesList_GamesList__MR-yE"};